<template>
	<v-dialog v-model="value" persistent :max-width="300">
		<v-card>
			<v-card-title class="subheading">{{ message }}</v-card-title>
			<v-card-text v-if="details">{{ details }}</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat @click="cancel">{{ cancelText }}</v-btn>
				<v-btn color="error" depressed @click="confirm">{{ confirmText }}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>


<script>
export default {
	name: "dialog-confirm",
	props: {
		message: String,
		details: String,
		cancelText: String,
		confirmText: String,
		value: Boolean,
	},
	methods: {
		confirm() {
			this.$emit('input', false);
			this.$emit('confirm');
		},
		cancel() {
			this.$emit('input', false);
			this.$emit('cancel');
		},
	},
}
</script>
